// import ContentLoader from "react-content-loader";

// const TimelineLoader = () => (
//   <ContentLoader 
//     speed={2} 
//     width="100%" 
//     height={200} 
//     viewBox="0 0 400 200" 
//     backgroundColor="#f3f3f3" 
//     foregroundColor="#ecebeb"
//   >
//     <rect x="10" y="20" rx="5" ry="5" width="80" height="10" />
//     <rect x="100" y="20" rx="5" ry="5" width="250" height="10" />
//     <rect x="10" y="50" rx="5" ry="5" width="80" height="10" />
//     <rect x="100" y="50" rx="5" ry="5" width="250" height="10" />
//     <rect x="10" y="80" rx="5" ry="5" width="80" height="10" />
//     <rect x="100" y="80" rx="5" ry="5" width="250" height="10" />
//   </ContentLoader>
// );



import ContentLoader from "react-content-loader";

const TimelineLoader = () => (
    <ContentLoader 
    speed={2} 
    width="100%" 
    height={120} 
    viewBox="0 0 400 120" 
    backgroundColor="#f3f3f3" 
    foregroundColor="#ecebeb"
  >
    {/* Circle 1 */}
    <circle cx="30" cy="30" r="20" />
    <rect x="10" y="55" rx="4" ry="4" width="40" height="10" />
    
    {/* Circle 2 */}
    <circle cx="120" cy="30" r="20" />
    <rect x="100" y="55" rx="4" ry="4" width="40" height="10" />
    
    {/* Circle 3 */}
    <circle cx="210" cy="30" r="20" />
    <rect x="190" y="55" rx="4" ry="4" width="40" height="10" />
    
    {/* Circle 4 */}
    <circle cx="300" cy="30" r="20" />
    <rect x="280" y="55" rx="4" ry="4" width="40" height="10" />
    

  </ContentLoader>
);
export default TimelineLoader